export default {
  en: {
    header: {
      about: 'About us',
      client: 'Client',
      contracts: 'My contracts',
      home: 'Home',
      logout: 'Logout',
      pro: 'Pro',
      profile: 'My profile',
      rfq: 'New service',
      scrollTop: 'Scroll to top',
      signin: 'Login'
    },
    login: {
      username: 'Username / Email',
      password: 'Password',
      submit_button: 'Log In',
      illustration_h1: 'Finding the best solution for your waste',
      illustration_h2: 'Log in to access your customer account',
      signin: 'Login',
      new1: 'No account ?',
      new2: 'Create one',
      error: {
        wrong_password: 'Wrong login / password',
        account_validation_required: 'You need to confirm your account via the validation email'
      }
    },
    footer: {
      company: {
        header: 'Reterium',
        address: 'Paris, France',
        phone: 'Phone: (+33) 7 70 55 43 47',
        general: 'contact@reterium.com',
        press: 'Press: press@reterium.com',
        sales: 'Sales: sales@reterium.com'
      },
      contact: {
        email: 'contact@reterium.com',
        header: 'Contact',
        about: 'About',
        career: 'Career',
        press: 'Press',
        blog: 'Blog'
      },
      customer: {
        header: 'Waste producer',
        customer_howto: 'How it works',
        customer_signup: 'Sign up now',
        customer_servicesnear: 'Services around me',
        customer_cost: 'Cost estimates'
      },
      pro: {
        header: 'Waste Manager',
        pro_howto: 'How it works',
        pro_signup: 'Sign up now',
        pro_servicesnear: 'Services around me',
        pro_cost: 'Cost estimates'
      },
      support: {
        header: 'Support',
        helpcenter: 'Help Center',
        safety: 'Safety',
        termsofuse: 'Terms of use',
        privacy: 'Privacy'
      },
      copyrights: "All rights reserved."
    },
    customer: {
      company: {
        header: 'Company information',
        description: 'Fill in information regarding your company',
        form: {
          business_name: {
            title: 'Business name',
            description: "",
            placeholder: 'Enter your business name'
          },
          business_type: {
            title: 'Business type',
            description: "",
            placeholder: 'Enter your business type'
          },
          email: {
            title: 'Email',
            description: "",
            placeholder: 'company@email.com'
          },
          phone_number: {
            title: 'Phone Number',
            description: "",
            placeholder: 'ex: +1 1111 2222 333'
          },
          address: {
            title: 'Address',
            description: "",
            placeholder: 'Enter your business address'
          },
          zip_code: {
            title: 'ZIP code',
            description: "",
            placeholder: 'Enter your business zip code'
          },
          same_address: {
            title: 'Use a different address for pick-ups',
            header: 'Address used for pickups',
            description: "",
            placeholder: 'Enter the pick-up address'
          },
          country_selection: {
            title: 'Country',
            header: 'Country of the company',
            description: "",
            placeholder: 'Select...'
          },
          password: {
            title: 'Password',
            header: 'Account password',
            description: "",
            placeholder: 'Enter a password'
          },
          password_validation: {
            title: 'Password validation',
            header: 'Account password validation',
            description: "",
            placeholder: 'Verify the password'
          }
        }
      },
      waste_type: {
        header: 'Waste type',
        description: 'Fill in information regarding the waste you produce',
        header_1: 'What kind of waste do you produce?',
        header_2: 'Describe us the conditioning of your waste',
        header_3: 'How much waste needs to be picked up?',
        header_4: 'Want to share a picture of your waste with professionals?',
        form: {
          waste_category: {
            title: 'Waste category',
            description: "",
            placeholder: 'Select a waste category'
          },
          waste_LER: {
            title: 'Waste LER code',
            description: "",
            placeholder: 'Select a LER code'
          },
          volume: {
            title: 'Volume / Weight',
            description: "",
            placeholder: 'Select an amount'
          },
          conditioning: {
            title: 'Conditioning',
            description: "",
            placeholder: 'Select a conditioning'
          },
          fully_sorted: {
            title: 'Is your waste fully sorted?',
            description: "",
            placeholder: 'false'
          },
          upload: {
            title: 'Upload a picture of your waste',
            description: "",
            placeholder: 'No file uploaded'
          }
        }
      },
      services: {
        header: 'Service details',
        description: 'Fill in information regarding the services you want',
        header_1: 'What type of service are you looking for?',
        header_2: 'When do you need waste to be picked up?',
        header_3: 'Need anything else?',
        form: {
          options: {
            title: 'Service options',
            description: "",
            placeholder: 'Select relevant options'
          },
          pickup_date: {
            title: 'Pick-up dates',
            add: 'Add a pickup date',
            description: "",
            placeholder: 'Select a date'
          },
          start_date: {
            title: 'Starting date',
            description: "",
            placeholder: 'Select a date'
          },
          pickup_hours: {
            title: 'Pick-up hours',
            description: "",
            placeholder: 'Select an hour'
          },
          pickup_frequency: {
            title: 'Pick-up frequency',
            description: "",
            placeholder: 'Select the pick-up frequency (per week)'
          },
          extra_services: {
            title: 'Extra services',
            description: "",
            placeholder: 'Select extra services'
          },
          specific_notifications: {
            title: 'Specific notifications or requests',
            description: "",
            placeholder: 'Anything else you want to inform the waste professional?'
          }
        }
      },
      completion: {
        email: 'Hi,<br/>Thank you for trusting Reterium!<br/>We confirm the registration of your profile on our platform<br/>We will inform you of all offers from waste professionals for your request.<br/><br>See you soon!<br/><br/>Regards,<br/>Reterium team',
        redirect_account:'Go to my account',
        redirect_homepage:'Return to homepage',
        title_connected: 'Request validated!',
        title_new: 'Thank you for choosing Reterium!',
        description_connected: 'Your request for quotation is now publicly visible',
        description_new: 'A confirmation email has been sent to your email address!'
      },
      general: {
        button: {
          next_step: "Continue",
          previous_step: "Back",
          final_step: "Finalize",
          reset: "Reset"
        },
        asterix: '* mandatory field'
      },
      validation: {
        header: 'Account activation',
        description: 'Only one step left!',
        offer_message: ' You\'ll soon get access to waste professionals offers\n',
        email_validation: 'A validation email will be sent to this address',
        emailSubject: 'Reterium - Account validation',
        emailGreetings: 'Hello ',
        emailBody1: ',<br><br>Thank you for choosing Reterium!<br>To access offers from waste professionals, confirm your account by <a href="',
        emailBody2: '">clicking on this link</a> !<br><br>If you didn\'t post a request on Reterium website, please ignore this email.<br>',
        emailGoodbye: '<br>See you soon on our platform!<br>Reterium team',
        password_input: 'Please choose a password to validate your account',
        email_sent: {
          thanks: 'Thank you for choosing Reterium!',
          confirmation: 'A confirmation email has been sent to your email address',
          activation: 'Your request for quotation is now visible to all waste professionals!'
        }
      },
      options: {
        waste_type: {
          placeholder: "Select a waste type",
          options: [
          {
            'value': "Hazardous",
            'text': "HAZARDOUS",
            $isDisabled: true
          },
          {
            'value': "WEEE",
            'text': "Waste Electrical and electronic equipement (WEEE)"
          },
          {
            'value': "Dirty empty packing",
            'text': "Dirty empty packing"
          },
          {
            'value': "Soiled, recyclable or incinerated solvents",
            'text': "Soiled, recyclable or incinerated solvents"
          },
          {
            'value': "Fluids of use",
            'text': "Fluids of use"
          },
          {
            'value': "Used oils",
            'text': "Used oils"
          },
          {
            'value': "Baths and surface treatment sludges",
            'text': "Baths and surface treatment sludges"
          },
          {
            'value': "Batteries",
            'text': "Batteries"
          },
          {
            'value': "Production waste",
            'text': "Production waste"
          },
          {
            'value': "PPE",
            'text': "Personal Protective Equipement"
          },
          {
            'value': "Soiled cloth",
            'text': "Soiled cloth"
          },
          {
            'value': "Treated wood",
            'text': "Treated wood"
          },
          {
            'value': "Non hazardous",
            'text': "NON HAZARDOUS",
            $isDisabled: true
          },
          {
            'value': "Glass",
            'text': "Glass"
          },
          {
            'value': "Metals",
            'text': "Metals"
          },
          {
            'value': "Plastic",
            'text': "Plastic"
          },
          {
            'value': "Textile",
            'text': "Textile"
          },
          {
            'value': "Cardboard",
            'text': "Cardboard"
          },
          {
            'value': "Wood",
            'text': "Wood"
          },
          {
            'value': "Organic matter of vegetable or animal origin",
            'text': "Organic matter of vegetable or animal origin"
          },
          {
            'value': "Used unsoiled packaging",
            'text': "Used unsoiled packaging"
          },
          {
            'value': "Production waste and unstained materials",
            'text': "Production waste and unstained materials"
          },
          {
            'value': "Used products",
            'text': "Used products"
          },
          {
            'value': "Others",
            'text': "OTHER",
            $isDisabled: true
          },
          {
            'value': "Other",
            'text': "Other"
          }]
        },
        waste_LER: {
          placeholder: "Select a LER code",
          options: [
          {
            'value': "17-02-01",
            'text': "17 02 01 wood"
          },
          {
            'value': "20-01-39",
            'text': "20 01 39 plastics"
          },
          {
            'value': "20-01-40",
            'text': "20 01 40 metals"
          },
          {
            'value': "20-01-10",
            'text': "20 01 10 clothes"
          },
          {
            'value': "20-01-02",
            'text': "20 01 02 glass"
          },
          {
            'value': "19-02-08",
            'text': "19 02 08* liquid combustible wastes containing dangerous substances"
          },
          {
            'value': "17-04-06",
            'text': "17 04 06 tin"
          },
          {
            'value': "17-04-05",
            'text': "17 04 05 iron and steel"
          },
          {
            'value': "17-04-04",
            'text': "17 04 04 zinc"
          },
          {
            'value': "17-04-03",
            'text': "17 04 03 lead"
          },
          {
            'value': "17-01-02",
            'text': "17 01 02 bricks"
          },
          {
            'value': "17-01-01",
            'text': "17 01 01 concrete"
          },
          {
            'value': "06-07-01",
            'text': "06 07 01* wastes containing asbestos from electrolysis"
          }]
        },
        conditioning: {
          placeholder: "Select a conditioning",
          options: [
          {
            'value': "Garbage bag",
            'text': "Garbage bag"
          },
          {
            'value': "Garbage container",
            'text': "Garbage container"
          },
          {
            'value': "Open top container",
            'text': "Open top container"
          },
          {
            'value': "Other",
            'text': "Other"
          }]
        },
        services: {
          title: 'Service type you\'re looking for',
          placeholder: "Select a service type",
          options: [
          {
            'value': "Spot",
            'text': "Spot"
          },
          {
            'value': "Long-term",
            'text': "Long-term contract"
          }]
        },
        extra_services: {
          placeholder: "Select desired extra services",
          options: [
          {
            'value': "Container",
            'text': "Rental of waste storage container"
          },
          {
            'value': "Other",
            'text': "Other services"
          }]
        }
      }
    },
    professional: {
      preview: {
        banner: {
          content : "Expend you customer base in a few clicks with Reterium.\nWe list 100+ request for proposals, for waste and recycling services.\nFind out the best deals in your region, with Reterium.",
          header: "Request for services in your area",
          register: "Register to find out more"
        },
        card: {
          count: 'requests for quotations found in your region',
          count_null: 'Unfortunately, no request for quotation is available for your region',
          date: 'Starting date : ',
          subscribe: 'I\'m interested',
          subscribe_customer: 'Register now as a waste producer',
          subscribe_professional: 'Register now as a waste professional'
        }
      },
      company: {
        header: 'Company information',
        description: 'Fill in information regarding your company',
        form: {
          business_name: {
            title: 'Business name',
            description: "",
            placeholder: 'Enter your business name'
          },
          business_type: {
            title: 'Business type',
            description: "",
            placeholder: 'Enter your business type'
          },
          email: {
            title: 'Email',
            description: "",
            placeholder: 'company@email.com'
          },
          phone_number: {
            title: 'Phone Number',
            description: "",
            placeholder: 'ex: +1 1111 2222 333'
          },
          address: {
            title: 'Address',
            description: "",
            placeholder: 'Enter your business address'
          },
          zip_code: {
            title: 'ZIP code',
            description: "",
            placeholder: 'Enter your business zip code'
          },
          siret_code: {
            title: 'SIRET code',
            description: "",
            placeholder: 'Enter your SIRET code'
          }
        }
      },
      waste_type: {
        header: 'Waste type',
        header_1: 'What kind of waste do you manage?',
        header_2: 'How about the waste conditioning?',
        header_3: 'What amount of waste can you handle?',
        description: 'Fill in information regarding the waste your company handles',
        form: {
          waste_category: {
            title: 'Waste categories',
            description: "",
            placeholder: 'Select your waste category'
          },
          waste_LER: {
            title: 'Waste LER code',
            description: "",
            placeholder: 'Select a LER code'
          },
          volume: {
            title: 'Volume / Weight',
            description: "",
            placeholder: 'Select a range of waste quantity your company can handle'
          },
          conditioning: {
            title: 'Conditioning',
            description: "",
            placeholder: 'Select a conditioning'
          },
          fully_sorted: {
            title: 'Fully sorted waste only',
            description: "",
            placeholder: 'false'
          },
          upload: {
            title: 'Upload a picture',
            description: "",
            placeholder: 'No file uploaded'
          }
        }
      },
      services: {
        header: 'Service details',
        header_1: 'What type of service do you provide?',
        header_2: 'When will you be available?',
        header_3: 'How far from your location can you reach?',
        header_4: 'Do you provide additional services?',
        header_5: 'Anything else worth sharing?',
        description: 'Fill in information regarding the services you provide',
        form: {
          options: {
            title: 'Service options',
            description: "",
            placeholder: 'Select relevant options'
          },
          pickup_date: {
            title: 'Pick-up dates',
            add: 'Add a pickup date',
            description: "",
            placeholder: 'Select a date'
          },
          start_date: {
            title: 'Date of first availability',
            description: "",
            placeholder: 'Select a date'
          },
          pickup_hours: {
            title: 'Pick-up hours',
            description: "",
            placeholder: 'Select an hour'
          },
          pickup_frequency: {
            title: 'Pick-up frequency',
            description: "",
            placeholder: 'Select the pick-up frequency (per week)'
          },
          max_distance: {
            title: 'Distance for waste pickups (km)',
            description: "",
            placeholder: 'Select a maximum distance for pickups'
          },
          extra_services: {
            title: 'Extra services provided',
            description: "",
            placeholder: 'Select extra services'
          },
          specific_notifications: {
            title: 'Specific notifications or requests',
            description: "",
            placeholder: 'Anything else you want to inform customers?'
          }
        }
      },
      completion: {
        title: 'Thank you !',
        description: 'You will soon receive client requests via email',
        account:'Go to my account',
        email: 'Hi,<br/><br/>Thank you for trusting Reterium!<br/>We confirm the registration of your profile on our platform<br/>We will inform you of client requests relevant to your company.<br/><br>See you soon!<br/><br/>Regards,<br/>Reterium team'
      },
      general: {
        button: {
          next_step: "Continue",
          previous_step: "Back",
          final_step: "Finalize",
          reset: "Reset"
        },
        asterix: '* mandatory field'
      },
      options: {
        waste_type: {
          placeholder: "Select a waste type",
          options: [
          {
            'value': "Hazardous",
            'text': "HAZARDOUS",
            $isDisabled: true
          },
          {
            'value': "WEEE",
            'text': "Waste Electrical and electronic equipement (WEEE)"
          },
          {
            'value': "Dirty empty packing",
            'text': "Dirty empty packing"
          },
          {
            'value': "Soiled, recyclable or incinerated solvents",
            'text': "Soiled, recyclable or incinerated solvents"
          },
          {
            'value': "Fluids of use",
            'text': "Fluids of use"
          },
          {
            'value': "Used oils",
            'text': "Used oils"
          },
          {
            'value': "Baths and surface treatment sludges",
            'text': "Baths and surface treatment sludges"
          },
          {
            'value': "Batteries",
            'text': "Batteries"
          },
          {
            'value': "Production waste",
            'text': "Production waste"
          },
          {
            'value': "PPE",
            'text': "Personal Protective Equipement"
          },
          {
            'value': "Soiled cloth",
            'text': "Soiled cloth"
          },
          {
            'value': "Treated wood",
            'text': "Treated wood"
          },
          {
            'value': "Non hazardous",
            'text': "NON HAZARDOUS",
            $isDisabled: true
          },
          {
            'value': "Glass",
            'text': "Glass"
          },
          {
            'value': "Metals",
            'text': "Metals"
          },
          {
            'value': "Plastic",
            'text': "Plastic"
          },
          {
            'value': "Textile",
            'text': "Textile"
          },
          {
            'value': "Cardboard",
            'text': "Cardboard"
          },
          {
            'value': "Wood",
            'text': "Wood"
          },
          {
            'value': "Organic matter of vegetable or animal origin",
            'text': "Organic matter of vegetable or animal origin"
          },
          {
            'value': "Used unsoiled packaging",
            'text': "Used unsoiled packaging"
          },
          {
            'value': "Production waste and unstained materials",
            'text': "Production waste and unstained materials"
          },
          {
            'value': "Used products",
            'text': "Used products"
          },
          {
            'value': "Others",
            'text': "OTHER",
            $isDisabled: true
          },
          {
            'value': "Other",
            'text': "Other"
          }]
        },
        waste_LER: {
          placeholder: "Select a LER code",
          options: [
          {
            'value': "17-02-01",
            'text': "17 02 01 wood"
          },
          {
            'value': "20-01-39",
            'text': "20 01 39 plastics"
          },
          {
            'value': "20-01-40",
            'text': "20 01 40 metals"
          },
          {
            'value': "20-01-10",
            'text': "20 01 10 clothes"
          },
          {
            'value': "20-01-02",
            'text': "20 01 02 glass"
          },
          {
            'value': "19-02-08",
            'text': "19 02 08* liquid combustible wastes containing dangerous substances"
          },
          {
            'value': "17-04-06",
            'text': "17 04 06 tin"
          },
          {
            'value': "17-04-05",
            'text': "17 04 05 iron and steel"
          },
          {
            'value': "17-04-04",
            'text': "17 04 04 zinc"
          },
          {
            'value': "17-04-03",
            'text': "17 04 03 lead"
          },
          {
            'value': "17-01-02",
            'text': "17 01 02 bricks"
          },
          {
            'value': "17-01-01",
            'text': "17 01 01 concrete"
          },
          {
            'value': "06-07-01",
            'text': "06 07 01* wastes containing asbestos from electrolysis"
          }]
        },
        conditioning: {
          placeholder: "Select a conditioning",
          options: [
          {
            'value': "Garbage bag",
            'text': "Garbage bag"
          },
          {
            'value': "Garbage container",
            'text': "Garbage container"
          },
          {
            'value': "Open top container",
            'text': "Open top container"
          },
          {
            'value': "Other",
            'text': "Other"
          }]
        },
        services: {
          title: "Service type(s) you provide",
          placeholder: "Select a service type",
          options: [
          {
            'value': "Spot",
            'text': "Spot"
          },
          {
            'value': "Long-term",
            'text': "Long-term"
          }]
        },
        extra_services: {
          placeholder: "Select desired extra services",
          options: [
          {
            'value': "Container",
            'text': "Rental of waste storage container"
          },
          {
            'value': "Other",
            'text': "Other services"
          }]
        }
      },
      validation: {
        header: 'Account activation',
        description: 'Only one step left!',
        offer_message: ' You\'ll soon get access to requests for quotations\n',
        email_validation: 'A validation email will be sent to this address',
        emailSubject: 'Reterium - Account validation',
        emailGreetings: 'Hello ',
        emailBody1: ',<br><br>Thank you for choosing Reterium!<br>To access customer requests for quotations, confirm your account by <a href="',
        emailBody2: '">clicking on this link</a> !<br><br>If you didn\'t register on Reterium website, please ignore this email.<br>',
        emailGoodbye: '<br>See you soon on our platform!<br>Reterium team',
        password_input: 'Please choose a password to validate your account',
        email_sent: {
          thanks: 'Thank you for choosing Reterium!',
          confirmation: 'A confirmation email has been sent to your email address',
          activation: 'You can now access customer requests for quotations!'
        }
      },
    },
    my_rfqs: {
      table: {
        title: 'Request for quotations',
        count: 'requests for quotations currently open',
        count_null: 'You have no request for quotation currently open',
        new_rfq_card: {
          create: 'Create a new request for quotation',
          description: 'You have waste that needs to be taken care of?'
        }
      },
      menu: {
        name: 'Username',
        my_rfqs: 'My requests',
        my_contracts: 'My contracts',
        inbox: 'Inbox',
        my_profile: 'My profile'
      }
    },
    public_rfqs: {
      table: {
        title: 'Request for quotations',
        count: 'requests for quotations found',
        count_null: 'There are currently no requests for quotations available'
      },
      menu: {
        name: 'Username',
        public_rfqs: 'Public RFQs',
        my_contracts: 'My contracts',
        inbox: 'Inbox',
        my_profile: 'My profile'
      },
      card: {
        agree_terms_conditions: 'I accept contract terms as presented',
        contract_terms: 'Contract Terms',
        go_back: 'Go back',
        make_offer: 'Make an offer',
        price_offer: 'Price offer',
        publication_date: 'Published on',
        quotation: 'Quotation',
        start_date: 'Starts on',
        see_details: 'See details',
        terms_and_conditions: 'Terms and Conditions',
        recap: 'Request recap'
      }
    },
    homepage: {
      cardsContent : {
        init: [
        {
          title: 'Learn about the processing of waste',
          content: 'Regulations and procedures regarding waste treatment management',
          icon: 'static/icons/documentation.png',
          redirect: '/documentation'
        },
        {
          title: 'Setup a waste collection service',
          content: 'Our marketplace allows you to find the best offer from waste collectors. Say goodbye to inflated fees',
          icon: 'static/icons/dump-truck.png',
          redirect: '/services'
        }]
      },
      cardsTree: {
        init: {
        }
      },
      section_1: {
        title: 'Find the best solution for your waste',
        subtitle: 'Reterium helps companies find the best solution for their waste and unleash new market opportunites for waste haulers.',
        register_client: 'I produce waste',
        register_professional: 'I manage waste',
        discover: 'Discover Reterium',
        waste_documentation: 'Understand Waste Treatment processes',
        waste_services: 'Services for your Waste'
      },
      section_2: {
        title: 'What we do',
        content: 'We are a market place bringing together production companies looking to find recycling and disposal services with the best waste management companies in your region. By eliminating the information barriers we are enabling production companies to find the best service providers for their waste'
      },
      section_3: {
        title: 'Our solution is simple and adaptive',
        content: 'We help companies of all sizes managing their waste in a more efficient way.\nThis means we support you in the process of finding the contract that is right for you, guide you through the documentation and paper work and finally store it for you in one single, easily managed place. This helps you focus on what you are good at and we are doing the garbage work for you!',
        register_client: 'Find the best solution for your waste',
        register_professional: 'Find the best waste offers'
      },
      section_4: {
        title: 'Our beliefs',
        content: 'There is only one planet and there is only so much budget for waste management. By better matching producers and recyclers we can make the industry more efficient. This leads to lower waste management costs for producers and more efficient recycling of materials. We want to help our customers doing well by doing good!'
      },
      banner: {
        title: 'Register now and join our community',
        register_client: 'I produce waste  >',
        register_professional: 'I manage waste  >'
      }
    },
    documentation: {
      section_1: {
        title: 'Documentation and laws regarding waste',
        subtitle: ''
      },
      cardsContent : {
        doc: [
        {
          title: 'Construction Materials <span class="font-italic">(Soon available!)</span class="font-italic">',
          content: 'Find information for non dangerous construction materials',
          background_: 'url("static/img/documentation/construction-materials.png")',
        },
        {
          title: 'Dangerous Materials <span class="font-italic">(Soon available!)</span class="font-italic">',
          content: 'Dangerous materials require special attention and handling',
          background_: 'url("static/img/documentation/hazardous-waste.jpg")'
        },
        {
          title: 'General information <span class="font-italic">(Soon available!)</span class="font-italic">',
          content: 'Find here the information you need to properly handle your waste according to legal processes',
          background_: 'url("static/img/documentation/general-information.jpg")'
        }],
        general_information: [
          {
            title: 'Waste treatment <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Learn about the process of treating all kinds of waste',
            background: ''
          },{
            title: 'Waste Legislation <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'The processes to handle waste are striclty regulated. Keep up to date with the latest laws regarding waste',
            background: ''
          }
        ],
        dangerous_material: [
          {
            title: 'Dangerous Material 1 <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Description of dangerous material 1',
            background: '',
            redirect: 'documentation/dangerous_material1'
          },
          {
            title: 'Dangerous Material 2 <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Description of dangerous material 2',
            background: '',
            redirect: 'documentation/dangerous_material2'
          },
          {
            title: 'Dangerous Material 3 <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Description of dangerous material 3',
            background: '',
            redirect: 'documentation/dangerous_material3'
          },
          {
            title: 'Dangerous Material 4 <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Description of dangerous material 4',
            background: '',
            redirect: 'documentation/dangerous_material4'
          }],
        safe_material: [
          {
            title: 'Plastic <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Learn recycling methods and cool facts about plastic',
            background: ''//,
            //redirect: 'documentation/plastic'
          },
          {
            title: 'Paper & wallpaper <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Learn recycling methods and cool facts about paper',
            background: ''//,
            //redirect: 'documentation/paper'
          },
          {
            title: 'Aluminium <span class="font-italic">(Soon available!)</span class="font-italic">',
            content: 'Learn recycling methods and cool facts about aluminium',
            background: ''//,
            //redirect: 'documentation/aluminium'
          }
        ]
      },
      cardsTree: {
        doc: {
          0: 'safe_material',
          1: 'dangerous_material',
          2: 'general_information'
        }
      }
    },
    services: {
      section_1: {
        title: 'Waste pickup services',
        subtitle: 'Setup waste pickups customized to your needs'
      },
      cardsContent : {
        service_selection: [
        {
          title: 'I produce waste',
          content: 'Your business produces waste? Let us handle it! We can connect ',
          background: '',
          redirect: '/customer'
        },{
          title: 'I manage waste',
          content: 'You are a waste professional which handles waste? We can help you find clients',
          background: '',
          redirect: '/professional'
        }]
      },
      cardsTree: {
        service_selection: {}
      }
    },
    global: {
      yes: 'Yes',
      no: 'No',
      loading: "Loading",
      errors: {
        null_input: 'Information required',
        email: {
          required: 'Email is required',
          invalid: 'Invalid email'
        },
        password: {
          required: 'A password is required',
          invalid: 'The password must contain at least 6 characters, including 1 lowercase, 1 uppercase characters and 1 number',
          unmatch: 'Passwords do not match'
        },
        text: {
          required: 'Input is required',
          invalid: 'Input must be less than 100 characters',
          invalid_long: 'Input must be less than 3000 characters'
        },
        phone: {
          required: 'Please specify a phone number',
          invalid: 'Invalid phone number'
        },
        zip: {
          required: 'Please specify a ZIP code',
          invalid: 'Invalid ZIP code'
        },
        volume: {
          too_low: 'Waste quantity is too small'
        },
        frequency: {
          too_low: 'Please select a higher pickup frequency'
        }
      },
      waste: {
        waste_type: {
          construction: 'Construction waste',
          paper: 'Paper waste',
          plastic: 'Plastic waste'
        },
        fully_sorted: {
          1: 'Fully sorted',
          0: 'Not fully sorted'
        },
        conditioning: {
          conditioned: 'Conditionned',
          unconditioned: 'Not conditioned'
        },
        volume: {
          liter: 'liter',
          meter: 'meter',
        },
        service_type: {
          spot: 'Spot contract',
          long_term: 'Long-term contract'
        }
      },
      status: {
        10: {
          text: 'Waiting for offers',
          class: 'initialization'
        },
        11: {
          text: 'Waiting for counter-offers',
          class: 'initialization'
        },
        12: {
          text: 'Offers available for validation',
          class: 'initialization'
        },
        20: {
          text: 'Contract modification requested',
          class: 'negociation'
        },
        21: {
          text: 'Contract modification approved',
          class: 'negociation'
        },
        22: {
          text: 'Contract modification rejected',
          class: 'negociation'
        },
        23: {
          text: 'Counter-modification proposed',
          class: 'negociation'
        },
        24: {
          text: 'Counter-modification approved',
          class: 'negociation'
        },
        25: {
          text: 'Counter-modification rejected',
          class: 'negociation'
        },
        30: {
          text: 'Contract signed by customer only',
          class: 'contractualization'
        },
        31: {
          text: 'Contract signed by pro only',
          class: 'contractualization'
        },
        40: {
          text: 'Contract in progress',
          class: 'contract_running'
        },
        50: {
          text: 'Conflict in progress',
          class: 'conflit_resolution'
        },
        51: {
          text: 'Conflict fix proposal',
          class: 'conflit_resolution'
        },
        52: {
          text: 'Conflict fix approved',
          class: 'conflit_resolution'
        },
        53: {
          text: 'Conflict fix rejected',
          class: 'conflit_resolution'
        },
        90: {
          text: 'Contract finished',
          class: 'contract_finished'
        },
      }
    }
  },
  fr: {
    header: {
      about: 'Infos',
      client: 'Client',
      contracts: 'Mes contrats',
      home: 'Accueil',
      logout: 'Déconnexion',
      pro: 'Pro',
      profile: 'Mon compte',
      rfq: 'Ajouter',
      scrollTop: 'Haut de page',
      signin: 'Se connecter'
    },
    login: {
      username: 'Identifiant / Email',
      password: 'Mot de passe',
      submit_button: 'Se connecter',
      illustration_h1: 'Trouvez la solution optimale pour vos déchets',
      illustration_h2: 'Nouveau client ? Dites-nous quels-sont vos besoins',
      signin: 'Se connecter',
      new1: 'Pas encore inscrit ?',
      new2: 'Créer un compte',
      error: {
        wrong_password: 'Identifiant ou mot de passe incorrect',
        account_validation_required: 'Vous devez cliquer sur lien de vérification envoyé par email'
      }
    },
    footer: {
      company: {
        header: 'Reterium',
        address: '414 Brannan Street - San Francisco, CA 94107, U.S.A',
        phone: 'Téléphone: (+33) 1 23 45 67 89',
        general: 'contact@reterium.com',
        press: 'Presse: press@reterium.com',
        sales: 'Commercial: sales@reterium.com'
      },
      contact: {
        email: 'contact@reterium.com',
        header: 'Contact',
        about: 'A propos',
        career: 'Carrière',
        press: 'Presse',
        blog: 'Blog'
      },
      customer: {
        header: 'Client',
        customer_howto: 'Comment ça marche',
        customer_signup: "S'inscrire",
        customer_servicesnear: 'Solutions à proximité',
        customer_cost: 'Estimation de coûts'
      },
      pro: {
        header: 'Gestionnaire de déchets',
        pro_howto: 'Comment ça marche',
        pro_signup: "S'inscrire",
        pro_servicesnear: 'Solutions à proximité',
        pro_cost: 'Estimation de coûts'
      },
      support: {
        header: 'Assistance',
        helpcenter: "Centre d'aide",
        safety: 'Sécurité',
        termsofuse: "Conditions d'utilisation",
        privacy: 'Vie privée'
      },
      copyrights: "Tous droits réservés."
    },
    customer: {
      company: {
        header: 'Votre entreprise',
        description: 'Apprenez-nous en sur votre entreprise.',
        form: {
          business_name: {
            title: 'Nom de votre entreprise',
            description: "",
            placeholder: 'Entrez le nom de votre entreprise'
          },
          business_type: {
            title: 'Secteur d\'entreprise',
            description: "",
            placeholder: 'Entrez le secteur de votre entreprise'
          },
          email: {
            title: 'Email',
            description: "",
            placeholder: 'company@email.com'
          },
          phone_number: {
            title: 'Numéro de téléphone',
            description: "",
            placeholder: 'ex: +33 1 23 45 67 89'
          },
          address: {
            title: 'Adresse',
            description: "",
            placeholder: 'Entrez l\'adresse de votre entreprise'
          },
          zip_code: {
            title: 'Code postal',
            description: "",
            placeholder: 'Entrez le code postal de votre entreprise'
          },
          same_address: {
            title: 'Utiliser une adresse différente pour le ramassage',
            header: 'Adresse pour les ramassages',
            description: "",
            placeholder: 'Entrer l\'adresse de ramassage'
          },
          country_selection: {
            title: 'Pays',
            header: 'Pays de l\'entreprise',
            description: "",
            placeholder: 'Choisir...'
          },
        }
      },
      waste_type: {
        header: 'Type de vos déchets',
        description: 'Dites-en nous davantage sur vos déchets',
        header_1: 'Quel type de déchet produisez-vous ?',
        header_2: 'Décrivez-nous l\'état de vos déchets',
        header_3: 'De combien de déchets parle-t-on ?',
        header_4: 'Vous pouvez ajouter une photo de vos déchets',
        form: {
          waste_category: {
            title: 'Catégorie des déchets',
            description: "",
            placeholder: 'Sélectionner une catégorie de déchets...'
          },
          waste_LER: {
            title: 'Code LER des déchets',
            description: "",
            placeholder: 'Sélectionnez une valeur...'
          },
          volume: {
            title: 'Volume / Poids',
            description: "",
            placeholder: 'Indiquer la quantité approximative des déchets'
          },
          conditioning: {
            title: 'Conditionnement',
            description: "",
            placeholder: 'Sélectionnez une valeur...'
          },
          fully_sorted: {
            title: 'Déchets complètement triés ?',
            description: "",
            placeholder: 'false'
          },
          upload: {
            title: 'Joindre une photo de vos déchets',
            description: "",
            placeholder: 'Aucun fichier importé'
          }
        }
      },
      services: {
        header: 'Services souhaités',
        description: 'Regardons précisément comment vous aider',
        header_1: 'Quel type de service recherchez-vous ?',
        header_2: 'Quand les déchets doivent-ils être ramassés ?',
        header_3: 'Avez-vous besoin d\'autre chose ?',
        form: {
          options: {
            title: 'Options',
            description: "",
            placeholder: 'Cocher les informations pertinentes'
          },
          pickup_date: {
            title: 'Jours de ramassage',
            add: 'Ajouter un jour de ramassage',
            description: "",
            placeholder: 'Choisir une date'
          },
          start_date: {
            title: 'Date de démarrage du service',
            description: "",
            placeholder: 'Choisir une date'
          },
          pickup_hours: {
            title: 'Heures de ramassage',
            description: "",
            placeholder: 'Choisir un horaire'
          },
          pickup_frequency: {
            title: 'Fréquence',
            description: "",
            placeholder: 'Choisir la fréquence de ramassage'
          },
          extra_services: {
            title: 'Autres services',
            description: "",
            placeholder: 'Renseigner d\'autres services souhaités'
          },
          specific_notifications: {
            title: 'Remarques ou demandes complémentaires',
            description: "",
            placeholder: 'Vous voulez partager une information avec le ramasseur concernant votre entreprise ou vos déchets ? Ecrivez ici votre message'
          }
        }
      },
      completion: {
        email: 'Bonjour,<br/><br/>Merci pour votre inscription sur notre plateforme Reterium !<br/>Nous vous confirmons la bonne réception de votre profil. <br/>Nous vous transmettrons par mail les propositions des professionnels du déchet en réponse à votre demande. <br/><br>A très bientôt !<br/><br/>Cordialement,<br/>L\'équipe Reterium',
        redirect_account:'Go to my account',
        redirect_homepage:'Return to homepage',
        title_connected: 'Request validated!',
        title_new: 'Thank you for choosing Reterium!',
        description_connected: 'Your request for quotation is now publicly visible',
        description_new: 'A confirmation email has been sent to your email address!'
      },
      general: {
        button: {
          next_step: "Continuer",
          previous_step: "Retour",
          final_step: "Valider",
          reset: "Réinitialiser"
        },
        asterix: '* champ obligatoire'
      },
      validation: {
        header: 'Création du compte',
        description: 'C\'est la dernière étape !',
        offer_message: 'Vous n\'êtes plus qu\'à un pas d\'accéder à toutes les offres des professionnels du déchet !\n',
        password_input: 'Merci de renseigner un mot de passe afin que nous vous créions un compte.',
        email_validation: 'Un email de validation vous sera envoyé à cet email :',
        emailSubject: 'Reterium - Confirmation de votre compte',
        emailGreetings: 'Bonjour ',
        emailBody1: '<br><br>Merci de faire confiance à Reterium !<br>Accédez aux offres des professionnels du déchet en <a href="',
        emailBody2: '">cliquant sur ce lien</a> !<br><br>Si vous n\'êtes l\'auteur de cette demande, merci d\'ignorer ce mail.<br>',
        emailGoodbye: '<br>Au plaisir de vous revoir sur notre plateforme !<br>L\'équipe Reterium',
        email_sent: {
          thanks: 'Merci d\'avoir choisi Reterium !',
          confirmation: 'Un mail de confirmation vient d\'être envoyé sur votre addresse.',
          activation: 'Votre appel d\'offre est désormais visible par tous les professionels du déchet !'
        }
      },
      options: {
        waste_type: {
          placeholder: "Choisir un type de déchets",
          options: [
          {
            'value': "Hazardous",
            'text': "DANGEREUX",
            $isDisabled: true
          },
          {
            'value': "WEEE",
            'text': "Déchets d\'équipements éléctriques et électroniques (DEEE)"
          },
          {
            'value': "Dirty empty packing",
            'text': "Emballages vides souillés"
          },
          {
            'value': "Soiled, recyclable or incinerated solvents",
            'text': "Solvants souillés, recyclables ou à incinérer"
          },
          {
            'value': "Fluids of use",
            'text': "Fluides d\'usage"
          },
          {
            'value': "Used oils",
            'text': "Huiles usagées"
          },
          {
            'value': "Baths and surface treatment sludges",
            'text': "Bains et boues de traitement de surface"
          },
          {
            'value': "Batteries",
            'text': "Piles et Batteries"
          },
          {
            'value': "Production waste",
            'text': "Déchets de production"
          },
          {
            'value': "PPE",
            'text': "Equipements de protection individuelle (EPI)"
          },
          {
            'value': "Soiled cloth",
            'text': "Chiffons souillés"
          },
          {
            'value': "Treated wood",
            'text': "Bois traités"
          },
          {
            'value': "Non hazardous",
            'text': "NON DANGEREUX",
            $isDisabled: true
          },
          {
            'value': "Glass",
            'text': "Verre"
          },
          {
            'value': "Metals",
            'text': "Metaux"
          },
          {
            'value': "Plastic",
            'text': "Plastique"
          },
          {
            'value': "Textile",
            'text': "Textile"
          },
          {
            'value': "Cardboard",
            'text': "Papier carton"
          },
          {
            'value': "Wood",
            'text': "Bois"
          },
          {
            'value': "Organic matter of vegetable or animal origin",
            'text': "Matière organique d\'origine végétale ou animale"
          },
          {
            'value': "Used unsoiled packaging",
            'text': "Emballages usagés non souillés"
          },
          {
            'value': "Production waste and unstained materials",
            'text': "Déchets de production et de matériaux non souillés"
          },
          {
            'value': "Used products",
            'text': "Produits usagés"
          },
          {
            'value': "Others",
            'text': "AUTRES",
            $isDisabled: true
          },
          {
            'value': "Other",
            'text': "Autre"
          }]
        },
        waste_LER: {
          placeholder: "Sélectionner un code LER",
          options: [
          {
            'value': "17-02-01",
            'text': "17 02 01 wood"
          },
          {
            'value': "20-01-39",
            'text': "20 01 39 plastics"
          },
          {
            'value': "20-01-40",
            'text': "20 01 40 metals"
          },
          {
            'value': "20-01-10",
            'text': "20 01 10 clothes"
          },
          {
            'value': "20-01-02",
            'text': "20 01 02 glass"
          },
          {
            'value': "19-02-08",
            'text': "19 02 08* liquid combustible wastes containing dangerous substances"
          },
          {
            'value': "17-04-06",
            'text': "17 04 06 tin"
          },
          {
            'value': "17-04-05",
            'text': "17 04 05 iron and steel"
          },
          {
            'value': "17-04-04",
            'text': "17 04 04 zinc"
          },
          {
            'value': "17-04-03",
            'text': "17 04 03 lead"
          },
          {
            'value': "17-01-02",
            'text': "17 01 02 bricks"
          },
          {
            'value': "17-01-01",
            'text': "17 01 01 concrete"
          },
          {
            'value': "06-07-01",
            'text': "06 07 01* wastes containing asbestos from electrolysis"
          }]
        },
        conditioning: {
          placeholder: "Choisir un type de conditionnement",
          options: [
          {
            'value': "Garbage bag",
            'text': "Sac poubelle"
          },
          {
            'value': "Garbage container",
            'text': "Conteneur poubelle"
          },
          {
            'value': "Open top container",
            'text': "Conteneur Open Top"
          },
          {
            'value': "Other",
            'text': "Autres conditionnements"
          }]
        },
        services: {
          title: "Sélection du type de service souhaité",
          placeholder: "Sélectionner le type de service souhaité",
          options: [
          {
            'value': "Spot",
            'text': "Unitaire"
          },
          {
            'value': "Long-term",
            'text': "Contrat longue durée"
          }]
        },
        extra_services: {
          placeholder: "Choisir des services supplémentaires",
          options: [
          {
            'value': "Container",
            'text': "Location de conteneur de stockage de déchets"
          },
          {
            'value': "Other",
            'text': "Autres services"
          }]
        }
      }
    },
    professional: {
      preview: {
        banner: {
          content : "Elargissez votre clientèle très facilement avec Reterium.\nNous regroupons des centaines d\'appels d\'offre, pour le traitement et le recyclage des déchets.\nAvec Reterium, venez découvrir les meilleures opportunités dans votre région !",
          header: "Appels d\'offres à proximité",
          register: "Je m\'inscrits pour découvrir "
        },
        card: {
          count: 'appels d\'offres trouvés pour votre région',
          count_null: 'Il n\'y a malheureusement aucun appel d\'offre pour votre région',
          date: 'Début : ',
          subscribe: 'Intéressant !',
          subscribe_customer: 'Inscription - Créateur de déchets',
          subscribe_professional: 'Inscription - Professionnel du déchet'
        }
      },
      company: {
        header: 'Votre entreprise',
        description: 'Apprenez-nous en sur votre entreprise.',
        form: {
          business_name: {
            title: 'Nom de votre entreprise',
            description: "",
            placeholder: 'Entrez le nom de votre entreprise'
          },
          business_type: {
            title: 'Secteur d\'entreprise',
            description: "",
            placeholder: 'Entrez le secteur de votre entreprise'
          },
          email: {
            title: 'Email',
            description: "",
            placeholder: 'company@email.com'
          },
          phone_number: {
            title: 'Numéro de téléphone',
            description: "",
            placeholder: 'ex: +33 1 23 45 67 89'
          },
          address: {
            title: 'Adresse',
            description: "",
            placeholder: 'Entrez l\'adresse de votre entreprise'
          },
          zip_code: {
            title: 'Code postal',
            description: "",
            placeholder: 'Entrez le code postal de votre entreprise'
          },
          siret_code: {
            title: 'SIRET code',
            description: "",
            placeholder: 'Entrez votre code SIRET'
          }
        }
      },
      waste_type: {
        header: 'Type de vos déchets',
        header_1: 'Quel type de déchet gérez-vous ?',
        header_2: 'Quel conditionnement pour les déchets ?',
        header_3: 'De combien de déchets parle-t-on ?',
        description: 'Dites-en nous plus sur les déchets que vous gérez',
        form: {
          waste_category: {
            title: 'Catégorie des déchets',
            description: "",
            placeholder: 'Sélectionner une catégorie de déchets...'
          },
          waste_LER: {
            title: 'Code LER des déchets',
            description: "",
            placeholder: 'Sélectionnez une valeur...'
          },
          volume: {
            title: 'Volume / Poids',
            description: "",
            placeholder: 'Indiquer un interval de quantité de déchets que vous pouvez traiter'
          },
          conditioning: {
            title: 'Conditionnement',
            description: "",
            placeholder: 'Sélectionnez une valeur...'
          },
          fully_sorted: {
            title: 'Déchets complètement triés uniquement',
            description: "",
            placeholder: 'false'
          },
          upload: {
            title: 'Joindre un fichier',
            description: "",
            placeholder: 'Aucun fichier importé'
          }
        }
      },
      services: {
        header: 'Services que vous proposez',
        header_1: 'Quels types de services proposez-vous ?',
        header_2: 'A partir de quand serez-vous disponible ?',
        header_3: 'A quelle distance pouvez-vous vous déplacer ?',
        header_4: 'Proposez-vous des services additionnels ?',
        header_5: 'Autre chose à partager ?',
        description: 'Regardons précisément comment vous pouvez aider nos clients',
        form: {
          options: {
            title: 'Options',
            description: "",
            placeholder: 'Cocher les informations pertinentes'
          },
          pickup_date: {
            title: 'Jours de ramassage',
            add: 'Ajouter un jour de ramassage',
            description: "",
            placeholder: 'Choisir une date'
          },
          start_date: {
            title: 'Date de démarrage du service',
            description: "",
            placeholder: 'Choisir une date'
          },
          pickup_hours: {
            title: 'Heures de ramassage',
            description: "",
            placeholder: 'Choisir un horaire'
          },
          pickup_frequency: {
            title: 'Fréquence',
            description: "",
            placeholder: 'Choisir la fréquence de ramassage'
          },
          max_distance: {
            title: 'Distance de couverture (km)',
            description: "",
            placeholder: 'Choisir une distance maximale pour le ramassage'
          },
          extra_services: {
            title: 'Autres services',
            description: "",
            placeholder: 'Renseigner d\'autres services souhaités'
          },
          specific_notifications: {
            title: 'Remarques ou demandes complémentaires',
            description: "",
            placeholder: 'Vous voulez partager une information avec le client concernant votre entreprise ou vos services ? Ecrivez ici votre message'
          }
        }
      },
      completion: {
        title: 'Merci !',
        description: 'Vous recevrez rapidement des demandes clients via votre email',
        account: 'Aller sur mon compte',
        email: 'Bonjour,<br/><br/>Merci pour votre inscription sur notre plateforme Reterium !<br/>Nous vous confirmons la bonne réception de votre profil. <br/>Nous vous tiendrons informé par mail des besoins de clients adaptés à votre profil. <br/><br>A très bientôt !<br/><br/>Cordialement,<br/>L\'équipe Reterium'
      },
      general: {
        button: {
          next_step: "Continuer",
          previous_step: "Retour",
          final_step: "Valider",
          reset: "Réinitialiser"
        },
        asterix: '* champ obligatoire'
      },
      options: {
        waste_type: {
          placeholder: "Choisir un type de déchets",
          options: [
          {
            'value': "Paper",
            'text': "Papier"
          },
          {
            'value': "Wood",
            'text': "Bois"
          },
          {
            'value': "Plastic",
            'text': "Plastique"
          },
          {
            'value': "Chemicals",
            'text': "Matières chimiques"
          },
          {
            'value': "Organics",
            'text': "Matières organiques"
          },
          {
            'value': "Other",
            'text': "Autres"
          }]
        },
        waste_LER: {
          placeholder: "Sélectionner un code LER",
          options: [
          {
            'value': "17-02-01",
            'text': "17 02 01 wood"
          },
          {
            'value': "20-01-39",
            'text': "20 01 39 plastics"
          },
          {
            'value': "20-01-40",
            'text': "20 01 40 metals"
          },
          {
            'value': "20-01-10",
            'text': "20 01 10 clothes"
          },
          {
            'value': "20-01-02",
            'text': "20 01 02 glass"
          },
          {
            'value': "19-02-08",
            'text': "19 02 08* liquid combustible wastes containing dangerous substances"
          },
          {
            'value': "17-04-06",
            'text': "17 04 06 tin"
          },
          {
            'value': "17-04-05",
            'text': "17 04 05 iron and steel"
          },
          {
            'value': "17-04-04",
            'text': "17 04 04 zinc"
          },
          {
            'value': "17-04-03",
            'text': "17 04 03 lead"
          },
          {
            'value': "17-01-02",
            'text': "17 01 02 bricks"
          },
          {
            'value': "17-01-01",
            'text': "17 01 01 concrete"
          },
          {
            'value': "06-07-01",
            'text': "06 07 01* wastes containing asbestos from electrolysis"
          }]
        },
        conditioning: {
          placeholder: "Choisir un type de conditionnement",
          options: [
          {
            'value': "Garbage bag",
            'text': "Sac poubelle"
          },
          {
            'value': "Garbage container",
            'text': "Conteneur poubelle"
          },
          {
            'value': "Open top container",
            'text': "Conteneur Open Top"
          },
          {
            'value': "Other",
            'text': "Autres conditionnements"
          }]
        },
        services: {
          title: "Sélection du type de service souhaité",
          placeholder: "Sélectionner le type de service souhaité",
          options: [
          {
            'value': "Spot",
            'text': "Unitaire"
          },
          {
            'value': "Long-term",
            'text': "Long-terme"
          }]
        },
        extra_services: {
          placeholder: "Select desired extra services",
          options: [
          {
            'value': "Container",
            'text': "Location de conteneur de stockage de déchets"
          },
          {
            'value': "Other",
            'text': "Autres services"
          }]
        }
      },
      validation: {
        header: 'Création du compte',
        description: 'C\'est la dernière étape !',
        offer_message: 'Vous n\'êtes plus qu\'à un pas d\'accéder aux demandes des entreprises sur le site !\n',
        password_input: 'Merci de renseigner un mot de passe pour la création de votre compte.',
        email_validation: 'Un email de validation vous sera envoyé à cette addresse mail :',
        emailSubject: 'Reterium - Confirmation de votre compte',
        emailGreetings: 'Bonjour ',
        emailBody1: '<br><br>Merci de faire confiance à Reterium !<br>Accédez à de nombreux appels d\'offres en <a href="',
        emailBody2: '">cliquant sur ce lien</a> !<br><br>Si vous n\'êtes l\'auteur de cette demande, merci d\'ignorer ce mail.<br>',
        emailGoodbye: '<br>Au plaisir de vous revoir sur notre plateforme !<br>L\'équipe Reterium',
        email_sent: {
          thanks: 'Merci d\'avoir choisi Reterium !',
          confirmation: 'Un mail de confirmation vient d\'être envoyé sur votre addresse.',
          activation: 'Vous avez désormais accès aux appels d\'offres des clients sur notre plateforme !'
        }
      },
    },
    my_rfqs: {
      table: {
        title: 'Appels d\'offres',
        count: 'appels d\'offres en cours',
        count_null: 'Aucun appel d\'offre en cours',
        new_rfq_card: {
          create: 'Lancer un nouvel appel d\'offre',
          description: 'Vous avez des déchets ? Trouvez un contrat avec un ramasseur'
        }
      },
      menu: {
        name: 'Username',
        my_rfqs: 'Mes appels d\'offres',
        my_contracts: 'Mes contrats',
        inbox: 'Messagerie',
        my_profile: 'Mon compte'
      }
    },
    public_rfqs: {
      table: {
        title: 'Appels d\'offres',
        count: 'appels d\'offres trouvés',
        count_null: 'Aucun appel d\'offre trouvé'
      },
      menu: {
        name: 'Username',
        public_rfqs: 'Appels d\'offres',
        my_contracts: 'Mes contrats',
        inbox: 'Messagerie',
        my_profile: 'Mon compte'
      },
      card: {
        agree_terms_conditions: 'J\'accepte les termes du contrat',
        contract_terms: 'Termes du contrat',
        go_back: 'Retour',
        make_offer: 'Faire une offre',
        price_offer: 'Votre prix',
        publication_date: 'Publiée le',
        quotation: 'Appel d\'offre',
        see_details: 'Voir détails',
        start_date: 'A partir du',
        terms_and_conditions: 'Termes et conditions du contrat',
        recap: 'Résumé de la demande'
      }
    },
    homepage: {
      cardsContent : {
        init: [
        {
          title: 'S\'informer sur le traitement de vos déchets',
          content: 'Réglementations et procédures encadrant le traitement de vos déchets',
          icon: 'static/icons/documentation.png',
          redirect: '/documentation'
        },
        {
          title: 'Mettre en place le ramassage de vos déchets',
          content: 'Notre marketplace vous permettra de comparer les offres des professionels. Trouvez le prix et le service qui vous correspondent',
          icon: 'static/icons/dump-truck.png',
          redirect: '/services'
        }]
      },
      cardsTree: {
        init: {
          0: 'doc',
          1: 'services'
        }
      },
      section_1: {
        title: 'Trouvez la solution la plus adaptée à vos déchets',
        subtitle: 'Reterium aide les entreprises à trouver des solutions sur-mesure pour leurs déchets permet aux professionels du déchet de trouver de nouveaux marchés',
        register_client: 'Je génère des déchets',
        register_professional: 'Je m\'occupe des déchets',
        discover: 'Découvrir Reterium',
        waste_documentation: 'Documentation sur les déchets',
        waste_services: 'Ramassage de vos déchets'
      },
      section_2: {
        title: 'Ce que Reterium vous apporte',
        content: 'Reterium est une plateforme qui réunit à la fois les entreprises, soucieuses de trouver des solutions de recyclage et ramassage des déchets, ainsi que les ramasseurs et professionnels du déchet de votre région. En supprimant les intermédiaires et en réunissant entreprises et professionnels, Reterirum permet à toute entreprise de trouver la meilleure solution pour ses déchets'
      },
      section_3: {
        title: 'Reterium est une solution simple et flexible',
        content: 'Nous aidons tout type d\'entreprises de mieux gérer leurs déchets.\nReterium vous aide à différents niveaux : trouver le contrat le plus avantageux et le plus adapté à votre besoin, puis vous aider dans la phase de documentation et dans les formalités administratives, mais aussi rassembler pour vous l\'ensemble des documents et informations essentielles dans un seul et même espace. Gardez votre énrgie sur votre business, nous allons gérer vos déchets pour vous !',
        register_client: 'Trouvez la solution la plus adaptée à vos déchets',
        register_professional: 'Je suis un professionel du déchet'
      },
      section_4: {
        title: 'Nos valeurs',
        content: 'Il est important de travailler ensemble à la sauvegarde de notre environnement. Nous sommes conscients que le budget de gestion des déchets reste limité pour les entreprises. Nous souhaitons apporter notre pierre à l\'édifice en permettant une meilleure communication entre créateurs et recycleurs de déchets. Avec cette plateforme, nous apportons une réduction des coûts de gestion des déchets, tout en permettant un recyclage plus efficace. Notre objectif est le suivant : aider votre entreprise à aller mieux, par des actions positives !'
      },
      banner: {
        title: 'Rejoignez notre communauté maintenant',
        register_client: 'Je crée des déchets  >',
        register_professional: 'Je gère les déchets  >'
      }
    },
    documentation: {
      section_1: {
        title: 'Documentation et lois relatives aux déchets',
        subtitle: 'Trouvez ici toutes informations spécifiques à vos déchets'
      },
      cardsContent : {
        doc: [
        {
          title: 'Matériaux de la construction <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
          content: 'Informations sur les matériaux de la construction non dangereux',
          background_: 'url("static/img/documentation/construction-materials.png")',
        },
        {
          title: 'Matériaux Dangereux <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
          content: 'Certains matériaux nécessitent un conditionnement et traitement spécifique',
          background_: 'url("static/img/documentation/hazardous-waste.jpg")'
        },
        {
          title: 'Informations générales <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
          content: 'Accéder aux réglementations et lois générales autour des déchets',
          background_: 'url("static/img/documentation/general-information.jpg")'
        }],
        general_information: [
          {
            title: 'Traitement des déchets <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Découvrer la procédure générale pour le traitement des déchets',
            background: ''
          },{
            title: 'Réglementation des déchets <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'De nombreuses régulations encadrent la gestion des déchets',
            background: ''
          }
        ],
        dangerous_material: [
          {
            title: 'Matériau dangereux 1 <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Description du matériau dangereux 1',
            background: '',
            redirect: 'documentation/dangerous_material1'
          },
          {
            title: 'Matériau dangereux 2 <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Description du matériau dangereux 2',
            background: '',
            redirect: 'documentation/dangerous_material2'
          },
          {
            title: 'Matériau dangereux 3 <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Description du matériau dangereux 3',
            background: '',
            redirect: 'documentation/dangerous_material3'
          },
          {
            title: 'Matériau dangereux 4 <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Description du matériau dangereux 4',
            background: '',
            redirect: 'documentation/dangerous_material4'
          }],
        safe_material: [
          {
            title: 'Plastique <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Apprenez en d\'avantage sur le plastique, notamment son recyclage',
            background: ''//,
            //redirect: 'documentation/plastic'
          },
          {
            title: 'Papier & Papier peint <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Apprenez en d\'avantage sur le papier, notamment son recyclage',
            background: ''//,
            //redirect: 'documentation/paper'
          },
          {
            title: 'Aluminium <span class="font-italic">(Bientôt disponible !)</span class="font-italic">',
            content: 'Apprenez en d\'avantage sur l\'aluminium, notamment son recyclage',
            background: ''//,
            //redirect: 'documentation/aluminium'
          }
        ]
      },
      cardsTree: {
        doc: {
          0: 'safe_material',
          1: 'dangerous_material',
          2: 'general_information'
        }
      }
    },
    services: {
      section_1: {
        title: 'Services de ramassage des déchets',
        subtitle: 'Mettez en place un service de ramassage adapté à vos besoins'
      },
      cardsContent : {
        service_selection: [
        {
          title: 'Je génère des déchets',
          content: 'Votre entreprise génère des déchets qui ont besoin d\'être ramassés',
          background: '',
          redirect: '/customer'
        },{
          title: 'Je traite les déchets',
          content: 'Vous êtes un professionel du déchet et offrez des services de ramassage',
          background: '',
          redirect: '/professional'
        }]
      },
      cardsTree: {
        service_selection: {}
      }
    },
    global: {
      yes: 'Oui',
      no: 'Non',
      loading: "Chargement",
      errors: {
        null_input: 'Information requise',
        email: {
          required: 'Un email est requis',
          invalid: 'Format d\'email non valide'
        },
        password: {
          required: 'Un mot de passe est requis',
          invalid: 'Le mot de passe doit contenir au minimum 6 caractères, dont 1 lettre miniscule, 1 lettre majuscule et 1 chiffre',
          unmatch: 'Les deux mots de passe entrés ne correspondent pas'
        },
        text: {
          required: 'Ce champ est requis',
          invalid: 'Texte trop long - limite de 100 caractères',
          invalid_long: 'Texte trop long - limite de 3000 caractères'
        },
        phone: {
          required: 'Un numéro de téléphone est requis',
          invalid: 'Format de numéro de téléphone non valide'
        },
        zip: {
          required: 'Ce champ est requis',
          invalid: 'Code postal non valide'
        },
        volume: {
          too_low: 'Quantité trop faible'
        },
        frequency: {
          frequency: 'Périodicité de ramassage trop faible'
        }
      },
      waste: {
        waste_type: {
          construction: 'Déchets de construction',
          paper: 'Déchets papiers',
          plastic: 'Déchets plastiques'
        },
        fully_sorted: {
          1: 'Complétement triés',
          0: 'Non triés'
        },
        conditioning: {
          conditioned: 'Conditionné',
          unconditioned: 'Non conditionnés'
        },
        volume: {
          liter: 'litre',
          meter: 'mètre'
        },
        service_type: {
          spot: 'Contrat unitaire',
          long_term: 'Contrat longue durée'
        }
      },
      status: {
        10: {
          text: 'Attende d\'offres',
          class: 'initialization'
        },
        11: {
          text: 'Attende de contre-offres',
          class: 'initialization'
        },
        12: {
          text: 'Offres en attente de validation',
          class: 'initialization'
        },
        20: {
          text: 'Modification de contrat demandée',
          class: 'negociation'
        },
        21: {
          text: 'Modification de contrat acceptée',
          class: 'negociation'
        },
        22: {
          text: 'Modification de contrat refusée',
          class: 'negociation'
        },
        23: {
          text: 'Contre-modification de contrat proposée',
          class: 'negociation'
        },
        24: {
          text: 'Contre-modification de contrat acceptée',
          class: 'negociation'
        },
        25: {
          text: 'Contre-modification de contrat refusée',
          class: 'negociation'
        },
        30: {
          text: 'Contrat signé par le client seulement',
          class: 'contractualization'
        },
        31: {
          text: 'Contrat signé par le ramasseur seulement',
          class: 'contractualization'
        },
        40: {
          text: 'Contrat en cours',
          class: 'contract_running'
        },
        50: {
          text: 'Conflit en cours',
          class: 'conflit_resolution'
        },
        51: {
          text: 'Proposition de résolution en attente',
          class: 'conflit_resolution'
        },
        52: {
          text: 'Proposition de résolution acceptée',
          class: 'conflit_resolution'
        },
        53: {
          text: 'Proposition de résolution refusée',
          class: 'conflit_resolution'
        },
        90: {
          text: 'Contract terminé',
          class: 'contract_finished'
        },
      }
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./lang/global.lang.js
// module id = 84
// module chunks = 1